
import { Options, Vue } from 'vue-class-component'

@Options({
    emits: ['close'],
    data() {
        return {

        }
    },
    methods: {
        closeClick() {
            this.$emit('close')
        },
    }
})
export default class Rule extends Vue { }
